import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withModifiers as _withModifiers, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "mx-auto px-40 xl:w-4/5" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "text-center font-bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link_conditional = _resolveComponent("router-link-conditional")!
  const _component_ConfirmationButton = _resolveComponent("ConfirmationButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.activationResultType !== null)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", {
            class: "text-center",
            innerHTML: _ctx.activationResultContent
          }, null, 8, _hoisted_2),
          (_ctx.activationResultSuccess)
            ? (_openBlock(), _createBlock(_component_router_link_conditional, {
                key: "activationSuccess",
                class: "inline-block c-magic-line c-magic-line--underline mt-30",
                to: _ctx.loginLink.url,
                "spa-enabled": _ctx.loginLink.spaLink,
                title: _ctx.labels.goToLoginButtonText,
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labels.goToLoginButtonText), 1)
                ]),
                _: 1
              }, 8, ["to", "spa-enabled", "title"]))
            : (_openBlock(), _createBlock(_component_router_link_conditional, {
                key: "activationFailure",
                class: "inline-block c-magic-line c-magic-line--underline mt-30",
                to: _ctx.createProfileLink.url,
                "spa-enabled": _ctx.createProfileLink.spaLink,
                title: _ctx.labels.goToCreateProfileButtonText,
                replace: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.labels.goToCreateProfileButtonText), 1)
                ]),
                _: 1
              }, 8, ["to", "spa-enabled", "title"]))
        ], 64))
      : (!_ctx.activationToken)
        ? (_openBlock(), _createBlock(_Transition, {
            key: 1,
            name: "o-anim-fade-300",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_ctx.resendError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", {
                      class: "text-center",
                      innerHTML: _ctx.labels.resendActivationErrorContent
                    }, null, 8, _hoisted_4),
                    _createVNode(_component_router_link_conditional, {
                      class: "inline-block c-magic-line c-magic-line--underline mt-30",
                      to: _ctx.createProfileLink.url,
                      "spa-enabled": _ctx.createProfileLink.spaLink,
                      title: _ctx.labels.goToCreateProfileButtonText,
                      replace: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.labels.goToCreateProfileButtonText), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "spa-enabled", "title"])
                  ]))
                : (_ctx.email)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", {
                        class: "text-center",
                        innerHTML: _ctx.$dictionary.formatNamed(_ctx.labels.activationContent, { email: _ctx.email })
                      }, null, 8, _hoisted_6),
                      _createElementVNode("form", {
                        class: "flex justify-center mt-30",
                        onSubmit: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resend && _ctx.resend(...args)), ["prevent"]))
                      }, [
                        _createVNode(_component_ConfirmationButton, {
                          class: "min-w-200 c-button--transparent",
                          confirm: _ctx.pending,
                          text: _ctx.labels.resendEmailButtonText,
                          "confirmation-text": _ctx.labels.resendEmailButtonPendingText
                        }, null, 8, ["confirm", "text", "confirmation-text"])
                      ], 32)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.labels.invalidEmailAddress), 1)
                    ]))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
  ]))
}